import { Component } from '@angular/core';
import { Extrainfo } from 'src/app/models/form/book-data';
import { FormDataService } from 'src/app/services/form-data.service';

@Component({
  selector: 'app-sandvik-other-details',
  templateUrl: './sandvik-other-details.component.html',
  styleUrls: ['./sandvik-other-details.component.scss']
})
export class SandvikOtherDetailsComponent {

  extrainfo:Extrainfo;

constructor (
  private formDataService : FormDataService ,  
  public formData : FormDataService
  ) 
  {

  this.extrainfo = formDataService.extrainfo;

}

}
